<template>
  <div class="box">
    <arrorImg bg="white"></arrorImg>
    <navBar title="章末推荐" color="#ffffff"></navBar>
    <div class="content-top">
      <span class="read-tips">{{
        bookFinish == 1
          ? "努力码字中，后续章节敬请期待..."
          : "恭喜你看完一本书！"
      }}</span>
      <div class="read_recommand">
        <div @click="routeFeedback">提意见</div>
        <div class="read_bookcity" @click="routeCity">
          <img src="../../../static/bookcity_icon.png" alt="" />
          <span>去书城</span>
        </div>
      </div>
    </div>
    <span class="recommand-title" v-if="item.bookName"
      >喜欢这本书的人正在读</span
    >
    <div>
      <div class="single-container" @click="clickToRead(item)" v-if="item.bookName">
        <div>
          <img class="single-image" :src="item.bookLogoUrl" alt="" />
        </div>
        <div class="single-description">
          <div class="single-top">
            <span class="single-title">{{ item.bookName }}</span>
            <span class="sort">{{ item.category }}</span>
          </div>
          <span class="single-brief">{{ item.bookSummary }}</span>
          <div class="single-bottom">
            <span class="single-title-right"
              >{{ item.studyingVolume }}万人在读</span
            >
            <span class="single-author">{{
              item.bookFinish === 0 ? "完结" : "连载"
            }}</span>
            <span class="single-author"> {{ item.bookNum }}万字</span>
          </div>
        </div>
      </div>
    </div>
    <span
      class="recommand-title"
      v-if="bookList.length > 0"
      style="margin-top: 1.25rem"
      >精彩推荐</span
    >
    <div class="list-content" v-if="bookList.length > 0">
      <div class="bookItem" v-for="(item, index) in bookList" :key="index">
        <div @click="clickToRead(item)">
          <div class="image_div" >
            <img  :src="item.bookLogoUrl" alt="" />
          </div>
          <div class="book_name">
            <span>{{ item.bookName }}</span>
          </div>
        </div>
      </div>
    </div>
    <span v-if="changeStatus == 1" class="change-btn" @click="changeData"
      >换一换</span
    >
  </div>
</template>
<script>
import arrorImg from "../../components/arrow-img.vue";
import navBar from "../components/navbar.vue";
import uniListitem from "../components/list-item.vue";
export default {
  components: {
    arrorImg,
    navBar,
    uniListitem,
  },
  data() {
    return {
      bookFinish: 1,
      frequency: 0,
      bookList: [],
      item: {
        bookSummary: "",
        bookLogoUrl: "",
        bookFinish: 1,
        studyingVolume: 0,
        category: "",
        bookName: "",
        bookNum: 0,
      },
      bookid: "",
      pageSize: 4,
      pageNo: 1,
      pageCount: 0,
      timer: null,
      fetchTime: 0,
      isReload: false,
      offest: 0,
      changeStatus: 3,
      isEntranceData: ""
    };
  },
  mounted() {
    if (this.$route.query.isEntranceData) {
      this.isEntranceData = this.$route.query.isEntranceData;
    }
    this.pageType= this.$route.query.pageType;
    this.bookFinish = this.$route.query.bookFinish;
    this.bookid = this.$route.query.bookid;
    var openid = this.$base.getStorage("openid");
    var isWxAuthorized = this.$base.getStorage("isWxAuthorized");
    var city = this.$base.getStorage("city");
    if (!openid) {
      //静默登录手动登录

    } else if (
      isWxAuthorized == 0 &&
      city == 1 &&
      openid &&
      !this.$store.state.user.isSNS
    ) {
      this.$base.setStorage("isSNS", true);
      this.$store.state.user.isSNS = true;
      this.$commonApi.snsapiUserinfo();
      this.getChangeItList();
      this.getNextBookInfo();
    
    } else {
      this.getChangeItList();
      this.getNextBookInfo();
   
    }
    this.$commonApi.share();
  },
  methods: {
    insertPageAccessData() {
      var pageType = "";
      if (this.pageType === "bookCity") {
        pageType = "书城";
      } else if (this.pageType === "bookRecharge") {
        pageType = "充值中心";
      }else if (this.pageType === "bookRead") {
        pageType = "阅读器";
      }
      var params = {
        pageName: "章末推荐",
        pageRemark: "上级页面："+pageType,
        isEntranceData: this.isEntranceData,
      };
      this.$api.insertPageAccessData(params).then((res) => {});
    },
    clickToRead(value) {
	   var isEntranceData = '(4:-1:-1:'+value.id+':-1:-1)' ;
      this.$router.push({
        path: "/pages/bookDetail/index",
        query: {
          bookId: value.id,
          pageType: "bookRecommandread",
          isEntranceData: isEntranceData,
        },
      });
    },
    changeData() {
      this.pageNo++;
      this.getChangeItList();
    },
    routeFeedback() {
      this.$router.push({
        path: "/pages/bookFeedback/index",
        query: {
          feedbackType: 1,
          pageType: "bookRecommandread",
        },
      });
    },
    routeCity() {
      this.$base.setStorage("tabbarIndex", 1);
      this.$router.replace({
        path: "/",
        query: {
          tabbarIndex: 1,
          pageType: "bookRecommandread",
        },
      });
    },
    getChangeItList() {
      var params = {
        bookId: this.bookid,
        pageNo: this.pageNo,
        pageSize: this.pageSize,
        offest: this.offest,
      };
      this.$api.getChangeItList(params).then((res) => {
        this.changeStatus = res.status;
        if (res.status === 1 || res.status === 3) {
          this.pageCount = res.pages;
          this.bookList = res.data;
          this.offest = res.offest;
          this.insertPageAccessData();
        }
      });
    },
    getNextBookInfo() {
      var params = {
        bookId: this.bookid,
      };
      this.$api.getNextBookInfo(params).then((res) => {
        if (res.status === 1 && res.data !== null) {
          var num = (res.data.studyingVolume / 10000).toFixed(2);
          if (num >= 999.99) {
            res.data.studyingVolume = 999.99;
          } else {
            res.data.studyingVolume = num;
          }
          this.item = res.data;
        }
      });
    },
  },
};
</script>

<style scoped>
.box {
  padding-bottom: 60px;
  /* padding: 0px 16px; */
}

.content-top {
  padding: 40px 10px;
  flex-direction: column;
  padding-top: calc(88px + env(safe-area-inset-top));
}
.read-tips {
  font-size: 16px;
  color: #333333;
  text-align: center;
  display: block;
}

.read_recommand {
  display: flex;
  margin-top: 20px;
  justify-content: center;
}

.read_recommand > div {
  border: 1px solid #aaaaaa;
  border-radius: 100px;
  width: 100px;
  height: 32px;
  text-align: center;
  line-height: 32px;
  font-size: 14px;
  color: #888888;
}
.read_recommand img {
  width: 16px;
  height: 16px;
  margin-top: 8px;
  margin-left: 17px;
  margin-right: 6px;
}

.read_recommand > .read_bookcity {
  border: 1px solid #de3b34;
  background-color: #de3b34;
  color: #ffffff;
  display: flex;
  margin-left: 16px;
}

.recommand-title {
  font-size: 16px;
  color: #333333;
  font-weight: bold;
  margin-bottom: 16px;
  display: block;
  padding: 0px 16px;
}

.single-container {
  display: flex;
  padding: 0px 16px;
}

.single-description {
  flex-direction: column;
  align-self: center;
}

.single-top {
  margin-bottom: 6px;
}

.single-image {
  width: 70px;
  height: 92px;
  margin-right: 12px;
  border-radius: 4px;
}

.single-title-right {
  font-size: 12px;
  color: #de3b34;
  margin-right: 12px;
}

.single-title {
  color: #333333;
  font-size: 15px;
  line-height: 21px;
  font-weight: bold;
}

.single-brief {
  color: #666666;
  font-size: 14px;
  line-height: 20px;
  margin-bottom: 10px;
  overflow: hidden;
  -webkit-line-clamp: 2;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
}
.single-bottom {
  justify-content: space-between;
  height: 17px;
  line-height: 17px;
}
.single-bottom > span {
  margin-right: 12px;
}
.single-author {
  color: #aaaaaa;
  font-size: 12px;
  align-self: center;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.single-div-clazz {
  justify-content: flex-end;
  width: 210px;
}

.sort {
  background-color: #fdf5e9;
  border-radius: 1px;
  text-align: center;
  line-height: 16px;
  border-radius: 2px;
  align-self: center;
  margin-left: 8px;
  padding: 0 2px;
  font-size: 10px;
  color: #f09b28;
  padding: 1px 3px;
}

.change-btn {
  background-color: #f7f7f7;
  border-radius: 8px;
  font-size: 14px;
  color: #aaaaaa;
  padding: 12px 0px;
  text-align: center;
  margin-top: 14px;
  display: block;
  width: 328px;
  margin-left: 16px;
}
.list-content {
  display: flex;
  /* justify-content: space-between; */
}
.list-content > div {
  margin-left: 16px;
}
.book_name > span {
  width: 70px;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  display: block;
  color: #333333;
  margin-top: 8px;
  font-size: 14px;
}
.image_div {
  width: 70px;
  height: 92px;
}

.image_div > img {
  width: 100%;
  height: 100%;
  border-radius: 10px;
}
</style>



// WEBPACK FOOTER //
// src/view/bookRecommandread/index.vue